/* Stock-first collection grid.
   Shopify sorts on the server and has no "in stock first" rule, so on any non-manual sort
   (price, name, date, best-selling) we rebuild the grid client-side: every in-stock page
   first, then every sold-out page, both in the chosen sort. Pages come from the Section
   Rendering API with the Search & Discovery availability filter toggled; the grid markup
   is whatever sections/collection-products.liquid renders, so cards stay identical.
   Server pagination is replaced by a "show more" button. Enabled by [data-colp-stockfirst]. */
(function () {
  var grid = document.querySelector('[data-colp-stockfirst]');
  if (!grid || !window.fetch || !window.DOMParser || !window.URL) return;

  var main = grid.closest('.colp-main');
  var sectionId = grid.getAttribute('data-section-id');
  var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 24;
  var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
  var t = {
    more: grid.getAttribute('data-t-load-more') || 'Daha Fazla Göster',
    retry: grid.getAttribute('data-t-retry') || 'Tekrar Dene',
    status: grid.getAttribute('data-t-status') || '[shown] / [total]',
    soldOut: grid.getAttribute('data-t-sold-out') || 'Tükenen Ürünler'
  };

  // Base URL: current sort + filters, minus page/section params.
  var base = new URL(window.location.href);
  base.searchParams.delete('page');
  base.searchParams.delete('sections');
  base.searchParams.delete('section_id');
  if (window.location.search !== base.search) history.replaceState(history.state, '', base.toString());
  var storeKey = 'colp-sf:' + base.pathname + base.search;

  // Stream of chunks: in-stock pages, then sold-out pages.
  var passes = [
    { avail: '1', page: 1, pages: null },
    { avail: '0', page: 1, pages: null }
  ];
  var passIdx = 0;
  var shown = 0;
  var replaced = false;   // server grid swapped for the composed one
  var busy = false;
  var dividerDone = false;

  var pagination = main ? main.querySelector('.colp-pagination') : null;
  var box = document.createElement('div');
  box.className = 'colp-loadmore';
  box.hidden = true;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'colp-loadmore-btn';
  btn.textContent = t.more;
  var status = document.createElement('p');
  status.className = 'colp-loadmore-status';
  status.setAttribute('aria-live', 'polite');
  box.appendChild(status);
  box.appendChild(btn);
  grid.insertAdjacentElement('afterend', box);

  function hasMore() { return passIdx < passes.length; }

  function fetchChunk(pass) {
    var u = new URL(base.toString());
    u.searchParams.set('filter.v.availability', pass.avail);
    u.searchParams.set('page', String(pass.page));
    u.searchParams.set('sections', sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        var html = json && json[sectionId];
        if (typeof html !== 'string') throw new Error('section missing');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('.colp-grid');
        return {
          cards: g ? [].slice.call(g.children) : [],
          pages: g ? (parseInt(g.getAttribute('data-colp-pages'), 10) || 1) : 0
        };
      });
  }

  function appendCards(cards, pass) {
    if (!replaced) {
      grid.innerHTML = '';
      replaced = true;
      if (pagination) pagination.remove();
    }
    if (pass.avail === '0' && shown > 0 && !dividerDone && cards.length) {
      var d = document.createElement('div');
      d.className = 'colp-stock-divider';
      d.setAttribute('role', 'separator');
      d.innerHTML = '<span></span>';
      d.firstChild.textContent = t.soldOut;
      grid.appendChild(d);
    }
    if (pass.avail === '0' && cards.length) dividerDone = true;
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(document.adoptNode(c)); });
    grid.appendChild(frag);
    shown += cards.length;
    document.dispatchEvent(new CustomEvent('colp:cards-added', { detail: { nodes: cards } }));
  }

  // Load the next chunk of the stream. Resolves with the number of cards appended.
  function next() {
    if (!hasMore()) return Promise.resolve(0);
    var pass = passes[passIdx];
    return fetchChunk(pass).then(function (res) {
      if (pass.pages === null) pass.pages = res.pages;
      appendCards(res.cards, pass);
      pass.page += 1;
      if (pass.page > pass.pages || res.cards.length === 0) passIdx += 1;
      return res.cards.length;
    });
  }

  // Keep loading until at least `min` more cards are on screen (or the stream ends).
  function loadUntil(min) {
    var got = 0;
    function step() {
      if (got >= min || !hasMore()) return Promise.resolve(got);
      return next().then(function (n) { got += n; return step(); });
    }
    return step();
  }

  function render(err) {
    if (main) main.classList.remove('colp-main--pending');
    grid.removeAttribute('aria-busy');
    btn.disabled = false;
    if (err) {
      btn.textContent = t.retry;
      box.hidden = !replaced; // untouched server grid + pagination still work
      return;
    }
    btn.textContent = t.more;
    btn.hidden = !hasMore();
    status.textContent = t.status.replace('[shown]', String(shown)).replace('[total]', String(total || shown));
    box.hidden = !replaced;
  }

  function remember() {
    try { sessionStorage.setItem(storeKey, JSON.stringify({ shown: shown, y: window.pageYOffset })); } catch (e) {}
  }

  function run(min, after) {
    if (busy) return;
    busy = true;
    grid.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    loadUntil(min)
      .then(function () { busy = false; render(); if (after) after(); })
      .catch(function (e) { busy = false; if (window.console) console.warn('[stock-first]', e); render(e); });
  }

  btn.addEventListener('click', function () { run(perPage); });
  window.addEventListener('pagehide', function () { if (replaced) remember(); });

  // Back-navigation: restore how far the shopper had scrolled through the stream.
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem(storeKey) || 'null'); } catch (e) {}
  var want = saved && saved.shown > perPage ? saved.shown : perPage;
  run(want, function () { if (saved && saved.y > 0) window.scrollTo(0, saved.y); });
})();
